import { PROJECTS_QUERY_KEY } from "@frontend-shared/constants";
import { useQuery } from "@tanstack/react-query";

import { projectApi } from "@/api/services";

export const useGetProjectPermissions = (enabled: boolean) => {
  return useQuery({
    queryKey: [PROJECTS_QUERY_KEY, "permissions"],
    queryFn: () => projectApi.getProjectPermissions(),
    enabled,
  });
};
